import { GB, PLAN_KB_WORDS, PLAN_STORAGE_GB, type Plan } from "./plans";
import type { LimitOverrides } from "./limitOverrides";

/** The plan's allowances, read only through here (plan §4.7; M7 round one: the catalogue row is the source). Pure: the caller loads
 *  the workspace's catalogue row (`loadPlan` in the server package, the one loader) and the two mail counts `mailUsage` gives. A
 *  missing row (a test that never wrote one) reads as the strictest defaults: no features, no credits, the abuse ceilings, Free's words. */
export type MailUsageCounts = { sentToday: number; sentThisMonth: number };
export type Entitlements = {
  plan: string; name: string;
  /** null = no cap */
  members: number | null; projects: number | null; ticketsMonth: number | null;
  /** the founder is told once a day when a workspace's tickets of its local day pass this; null = never */
  ticketsDayAlert: number | null;
  storageBytes: number; mailOutDay: number | null; mailOutMonth: number | null; canSendMail: boolean;
  /** the knowledge size: words per project (2026-10-13) */
  kbWordsPerProject: number;
  investigation: boolean; mcp: boolean; ownDomains: boolean; autoSend: boolean;
  /** M12 round one: the public API with keys */
  api: boolean;
  /** AI settings round three: the AI engines (false without a plan: fail closed) */
  ai: boolean;
  /** the credits a billing month grants (round two draws on them) */
  includedCredits: number;
};
/** a workspace without a plan row reads Free's storage (the files round, 2026-10-30: 1 GB) */
export const STORAGE_BYTES = PLAN_STORAGE_GB.free * GB;

/** the connector tags round (2026-10-27): `overrides`, the workspace's hand-set limits, win over the plan's mail caps (`effectiveLimit`'s rule) */
export function entitlements(plan: Plan | null | undefined, usage: MailUsageCounts, overrides?: Partial<Pick<LimitOverrides, "mailOutDay" | "mailOutMonth" | "storageBytes">> | null): Entitlements {
  const l = plan?.limits, f = plan?.features;
  const mailOutDay = overrides?.mailOutDay ?? l?.mailOutDay ?? null, mailOutMonth = overrides?.mailOutMonth ?? l?.mailOutMonth ?? null;
  const canSendMail = (mailOutDay === null || usage.sentToday < mailOutDay) && (mailOutMonth === null || usage.sentThisMonth < mailOutMonth);
  return {
    plan: plan?.id ?? "free", name: plan?.name ?? "Free",
    members: l ? l.members : 0, projects: l ? l.projects : 0, ticketsMonth: l ? l.ticketsMonth : null, ticketsDayAlert: l ? l.ticketsDayAlert : null,
    storageBytes: overrides?.storageBytes ?? l?.storageBytes ?? STORAGE_BYTES, mailOutDay, mailOutMonth, canSendMail, kbWordsPerProject: l?.kbWordsPerProject ?? PLAN_KB_WORDS.free,
    investigation: f?.investigation ?? false, mcp: f?.mcp ?? false, ownDomains: f?.ownDomains ?? false, autoSend: f?.autoSend ?? false, api: f?.api ?? false, ai: f?.ai ?? false,
    includedCredits: plan?.credits.includedMonth ?? 0,
  };
}
